export default "__VITE_ASSET__6af7f5b2__"